"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var moment = require("moment");
var react_redux_1 = require("react-redux");
require("./style.scss");
var actions_1 = require("./actions");
var model_1 = require("../../model");
var constants_1 = require("../../constants");
var PortalPage_1 = require("../_shared/components/PortalPage");
var layout_1 = require("../_shared/components/layout");
var ReportDateRange_1 = require("./partial/ReportDateRange");
var HoursPage = /** @class */ (function (_super) {
    __extends(HoursPage, _super);
    function HoursPage(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            dateFrom: moment().startOf('month').format(constants_1.DATE_FORMAT),
            dateTo: moment().format(constants_1.DATE_FORMAT),
        };
        return _this;
    }
    HoursPage.prototype.updateDate = function (dateFrom, dateTo) {
        this.setState({ dateFrom: dateFrom, dateTo: dateTo });
    };
    HoursPage.prototype.renderWeeklyReportTable = function (monday) {
        var _this = this;
        var day = moment(monday);
        var sunday = moment(monday).add(1, 'weeks');
        var displayedDateList = [];
        for (day; day.isBefore(sunday); day.add(1, 'days')) {
            displayedDateList.push(React.createElement("th", { colSpan: 3, key: day.format(constants_1.DATE_FORMAT) }, day.format(constants_1.DISPLAY_DATE_FORMAT)));
        }
        var hourTitleList = [React.createElement("th", null, "Ingevuld"), React.createElement("th", null, "Geccorrigeerd"), React.createElement("th", { className: "gpsHours" }, "GPS")];
        var hourTitles = displayedDateList.map(function () { return _.map(hourTitleList); });
        var usersReports = function () {
            var validHoursClassName = function (reportDay) {
                var isNotValid = reportDay.approvedHours !== reportDay.registeredHours ||
                    Math.abs(reportDay.registeredHours - reportDay.spentWorkHours) >= constants_1.VALID_TIME_RANGE;
                return (isNotValid ? 'not-valid-hours' : '');
            };
            var displayHours = function (duration) {
                var displayedDuration = duration.toString().length > 2 ?
                    duration.toFixed(2) : duration;
                return displayedDuration.toString().replace('.', ',');
            };
            var reports = _.map(_this.props.hoursReportData, function (userReport) {
                var hoursRow = [];
                var shouldDrawUserRow = false;
                var userFullname = "".concat(userReport.user.firstName, " ").concat(userReport.user.lastName);
                var _loop_1 = function (date) {
                    var reportDay = _.find(userReport.reportDays, function (day) {
                        return day.date === date.format('YYYY-MM-DD');
                    });
                    if (reportDay) {
                        var className = validHoursClassName(reportDay);
                        if (className) {
                            shouldDrawUserRow = true;
                        }
                        hoursRow.push([
                            React.createElement("td", { className: className }, displayHours(reportDay.registeredHours)),
                            React.createElement("td", { className: className }, displayHours(reportDay.approvedHours)),
                            React.createElement("td", { className: className }, displayHours(reportDay.spentWorkHours))
                        ]);
                    }
                    else {
                        hoursRow.push([React.createElement("td", null), React.createElement("td", null), React.createElement("td", null)]);
                    }
                };
                for (var date = moment(monday); date.isBefore(sunday); date.add(1, 'days')) {
                    _loop_1(date);
                }
                return shouldDrawUserRow ?
                    React.createElement("tr", { key: userReport.user._id },
                        React.createElement("td", { className: 'user' }, userFullname),
                        hoursRow)
                    : null;
            });
            return reports;
        };
        var report = usersReports();
        return _.some(report) ?
            React.createElement("table", { className: "border week-report-table", key: 'table' + monday },
                React.createElement("thead", { key: 'head' + monday },
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        displayedDateList),
                    React.createElement("tr", null,
                        React.createElement("th", null),
                        hourTitles)),
                React.createElement("tbody", null, report)) : null;
    };
    /**
     * We render every week report with separated table. If registered, approved, gps hours are not
     * matched (difference greater than 7 minutes `VALID_TIME_RANGE`) then it should be marked with
     * red color.
     */
    HoursPage.prototype.reportTables = function () {
        var _this = this;
        var dateFrom = moment(this.state.dateFrom).startOf('week');
        var dateTo = moment(this.state.dateTo).endOf('week');
        var mondayList = [];
        for (var day = moment(dateFrom); day.isBefore(dateTo); day.add(1, 'week')) {
            mondayList.push(day.format('YYYY-MM-DD'));
        }
        return _.map(mondayList, function (date) { return _this.renderWeeklyReportTable(date); });
    };
    HoursPage.prototype.render = function () {
        var _this = this;
        return (React.createElement(PortalPage_1.default, { page: model_1.Permission.PAGE_REPORT_HOURS, isLoading: this.props.isLoading, id: "report" },
            React.createElement(layout_1.Row, { justifyContent: "flex-end" },
                React.createElement("span", { className: "button report-back-button", onClick: function () { return _this.props.history.goBack(); } }, "Ga Terug")),
            React.createElement(layout_1.Wrapper, { paddingVertical: "20px" },
                React.createElement(ReportDateRange_1.default, { dateFrom: this.state.dateFrom, dateTo: this.state.dateTo, onChangeDateFrom: function (date) { return _this.updateDate(date, _this.state.dateTo); }, onChangeDateTo: function (date) { return _this.updateDate(_this.state.dateFrom, date); }, onGenerate: function () { return _this.props.getReport(_this.state.dateFrom, _this.state.dateTo); } }),
                React.createElement(layout_1.Wrapper, { paddingVertical: '20px', className: 'report-wrapper' },
                    React.createElement(layout_1.Margin, { margin: "16px" }),
                    this.reportTables(),
                    React.createElement(layout_1.Margin, { marginVertical: "32px" })))));
    };
    return HoursPage;
}(React.Component));
var mapStateToProps = function (_a) {
    var reducer = _a.reducer;
    return {
        isLoading: reducer.reportReducer.isLoading,
        hoursReportData: reducer.reportReducer.hoursReportData,
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    getReport: function (dateFrom, dateTo) { return actions_1.Actions.getHoursReport(dateFrom, dateTo)(dispatch); },
}); };
var ReportHoursPage = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(HoursPage);
exports.default = ReportHoursPage;
